import styled from "@emotion/styled";
import { TotalCountBadge } from "src/components/TotalCountBadge";
import { Agreement03 } from "src/assets/icons/agreement-03";
import { PrimaryButton } from "src/components/Buttons";

export const MainPaneContainer = styled.div<{ fullBleed?: boolean }>`
  flex-grow: 1;
  padding: ${({ fullBleed }) => (fullBleed ? "0" : "0px 34px 34px")};
  height: ${({ fullBleed }) => (fullBleed ? "100%" : "auto")};
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 34px 0px 50px;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const HeaderTitle = styled.div<{ isDashboard: boolean }>`
  color: rgba(17, 24, 39, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 600;
  text-transform: capitalize;
`;

export const HeaderSubTitle = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 14px
  font-weight: 400;
`;

export const InviteButton = styled(PrimaryButton)`
  font-size: 14px;
  height: 38px;
`;

export default ({
  showHeading,
  page,
  headerTitleText,
  totalCount,
  headerSubTitleText,
  children,
  fullBleed = false,
}: {
  showHeading: boolean;
  page: string;
  headerTitleText: string;
  totalCount?: number;
  headerSubTitleText: string;
  children: React.ReactNode;
  fullBleed?: boolean;
}) => {
  return (
    <MainPaneContainer fullBleed={fullBleed}>
      {showHeading && (
        <HeaderContainer>
          <HeaderTitleContainer>
            <HeaderTitle isDashboard={page === "dashboard"}>
              {headerTitleText}
              {totalCount ? (
                <TotalCountBadge>{totalCount}</TotalCountBadge>
              ) : null}
            </HeaderTitle>
            <HeaderSubTitle>{headerSubTitleText}</HeaderSubTitle>
          </HeaderTitleContainer>
        </HeaderContainer>
      )}
      {children}
    </MainPaneContainer>
  );
};
